module.exports = __webpack_public_path__ + "img/product_43.f2e3585.webp";